import { BrowserRouter, Routes, Route } from "react-router-dom";
import ChatBot from "./pages/JacaiChat";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import ScrollToTop from "./components/ScrollToTop";
import AboutJacai from "./pages/AboutJacai";
import ChatSelection from "./pages/ChatSelection";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<ChatSelection />} />
        <Route path="/educational-chat" element={<ChatBot />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/about-jacai" element={<AboutJacai />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
